export const getNfurecolectadoVSmetaestablecida = (data) => {
  if (!data) return {};

  const mesesOrdenados = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre",
  ];

  const months = mesesOrdenados.filter((m) =>
    data.some((item) => item.mes === m)
  );

  const cantidadRecolectada = months.map((m) => {
    const item = data.find((d) => d.mes === m);
    return item?.cantidad_recolectada || 0;
  });

  const metaOperativa = months.map((m) => {
    const item = data.find((d) => d.mes === m);
    return item?.meta_operativa || 0;
  });

   
  const totalRecolectado = cantidadRecolectada.reduce(
    (sum, val) => sum + val,
    0
  );
  const totalRecolectadoFormatted = totalRecolectado.toLocaleString();

  return {
    title: {
      text: "NFU Recolectado vs Meta Establecida",
      subtext: `TOTAL RECOLECTADOS: ${totalRecolectadoFormatted} NFU`,
      subtextStyle: {
        fontSize: Math.max(window.innerWidth * 0.02, 11),
        fontSize: 12,
        fontWeight: "bold",
      },
      left: "center",
      padding: [20, 10, 10, 10],
      textStyle: { fontSize: Math.max(window.innerWidth * 0.02, 14) },
    },
    tooltip: {
      confine: true,
      trigger: "axis",
      axisPointer: { type: "line" },
      backgroundColor: "#fff",
      borderColor: "#ccc",
      borderWidth: 1,
      textStyle: {
        fontSize: 11,  
        color: "#333",
      },
      formatter: (params) => {
         
        let str = `<span style="font-size:11px;">${params[0].axisValue}</span><br/>`;
        params.forEach((item) => {
          const valueFormatted = Number(item.value).toLocaleString();
          str += `<span style="font-size:11px;color:${item.color};">●</span> ${item.seriesName}: <b>${valueFormatted}</b><br/>`;
        });
        return str;
      },
    },
    legend: {
      data: ["Cantidad recolectada", "Meta operativa"],
      bottom: 0,
    },
    grid: {
      left: "3%",
      right: "4%",
      bottom: "10%",
      containLabel: true,
    },
    xAxis: {
      type: "category",
      boundaryGap: true,
      data: months,
      axisLabel: {
        formatter: (value) => value.substring(0, 3),
      },
    },
    yAxis: {
      type: "value",
      name: "",
      nameTextStyle: {
        fontSize: 11,
        padding: [-10, 0, 0, 0],
      },
      min: 0,
    },
    series: [
      {
        name: "Cantidad recolectada",
        type: "line",
        data: cantidadRecolectada,
      },
      {
        name: "Meta operativa",
        type: "line",
        data: metaOperativa,
      },
    ],
  };
};
